module.exports = __webpack_public_path__ + "img/dragan.b97990a4.jpg";